export default function (Vue, parent, _data) {
  var backdrop = {
    template: `
    <div class='__config__body'>
      <div class="_key">ID:&nbsp;<span v-text="params['id']"></span></div>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="基本属性" name="1">
           <el-form  label-width="65px">
              <el-form-item label="流程标识" v-show="false">
                  <el-input v-model="data['id']" :disabled="true">
                  </el-input>
              </el-form-item>
              <el-form-item label="流程KEY：">
                  <!--<el-input v-model="params['key']" :disabled="true">-->
                  <!--</el-input>-->
                  <span v-text="params['key']"></span>
              </el-form-item>
              <!--<el-form-item label="流程分类：">
                  <el-input v-model="data['category']">
                  </el-input>
              </el-form-item>-->
              <el-form-item label="流程名称：">
                  <el-input v-model="data['name']" ></el-input>
              </el-form-item>
              <!--<el-form-item label="流程简称：">
                  <el-input v-model="data['simpleName']" ></el-input>
              </el-form-item>
              <el-form-item label="流程序号：">
                  <el-input v-model="data['sn']" ></el-input>
              </el-form-item>-->
              <el-form-item label="适用范围：">
                  <el-input v-model="data['scopeName']" :disabled="true" style="width:65%"></el-input>
                  <el-button type="primary" @click="showUnit">选择</el-button>
              </el-form-item>

              <el-form-item label="适用范围：" v-show="false">
                  <el-input v-model="data['scope']" :disabled="true"></el-input>
              </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="任务映射" name="2">
             <el-form  label-width="65px">
                <el-form-item label="题名：">
                  <el-select v-model="data['businessName']" clearable filterable  key="businessName">
                    <el-option :label="item.name" :value="item.id" :key="item.id+'1'" v-for="item in fieldItems"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="关键字：">
                  <el-select v-model="data['businessKeyword']" clearable  filterable  key="businessKeyword">
                    <el-option :label="item.name" :value="item.id" :key="item.id+'2'" v-for="item in fieldItems"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="业务分类：">
                  <el-select v-model="data['businessCategory']" clearable filterable  key="businessCategory">
                    <el-option :label="item.name" :value="item.id" :key="item.id+'3'" v-for="item in fieldItems"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="紧急程度：">
                  <el-select v-model="data['urgencyLevel']" clearable  filterable  key="urgencyLevel">
                    <el-option :label="item.name" :value="item.id" :key="item.id+'4'" v-for="item in fieldItems"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="扩展字段1:">
                  <el-select v-model="data['businessField0']" clearable  filterable  key="businessField0">
                    <el-option :label="item.name" :value="item.id" :key="item.id+'5'" v-for="item in fieldItems"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="扩展字段2:">
                  <el-select v-model="data['businessField1']" clearable  filterable  key="businessField1">
                    <el-option :label="item.name" :value="item.id" :key="item.id+'6'" v-for="item in fieldItems"></el-option>
                  </el-select>
                </el-form-item>
             </el-form>
        </el-collapse-item>
        <el-collapse-item title="分发设置" name="3" class="__btn">
             <el-form  label-width="65px">
                <el-form-item label="接收单位：">
                  <el-button type="primary" @click="showApp('disDefUnit')">选择默认应用</el-button>
                </el-form-item>
                <div  style="padding:5px;padding-bottom:2px;margin-bottom:2px;border:1px #ddd solid" v-show="data.disDefUnit.length>0">
                   默认应用：<el-button  :key="it.id" v-for="it in data.disDefUnit">{{it.name}}
                   </el-button>
                </div>
                <table class="inner_table">
                  <colgroup>
                    <col style="width:108px">
                    <col style="width:108px">
                    <col style="width:39px">
                  </colgroup>
                  <tbody>
                    <tr><th>单位</th><th>应用</th><th><i class="fa fa-plus-square" @click="addDisUnit()" title="新增"></i></th></tr>
                    <tr :key="idx" v-for="(it,idx) in data.disUnit">
                    <td><input type='text' readonly :title="it['un']" @focus="showDisUnit(idx,'unit')" v-model="it['un']"/></td>
                    <td><input type='text' readonly :title="it['an']" @focus="showApp('unit',idx)" v-model="it['an']"/></td>
                    <td><i class="fa fa-minus-square" @click="delDisUnit(idx)"></i></td>
                    </tr>
                  </tbody>
                </table>
             </el-form>
             <el-form  label-width="65px">
                <el-form-item label="接收部门：">
                  <el-button type="primary" @click="showApp('disDefDept')">选择默认应用</el-button>
                </el-form-item>
                <div  style="padding:5px;margin-bottom:2px;padding-bottom:2px;border:1px #ddd solid" v-show="data.disDefDept.length>0">
                   默认应用：<el-button  :key="it.id" v-for="it in data.disDefDept">{{it.name}}
                   </el-button>
                </div>
                <table class="inner_table">
                  <colgroup>
                    <col style="width:108px">
                    <col style="width:108px">
                    <col style="width:39px">
                  </colgroup>
                  <tbody>
                    <tr><th>单位</th><th>应用</th><th><i class="fa fa-plus-square" @click="addDisDept()" title="新增"></i></th></tr>
                    <tr :key="idx" v-for="(it,idx) in data.disDept">
                    <td><input type='text' readonly :title="it['un']" @focus="showDisUnit(idx,'dept')" v-model="it['un']"/></td>
                    <td><input type='text' readonly :title="it['an']"  @focus="showApp('dept',idx)" v-model="it['an']"/></td>
                    <td><i class="fa fa-minus-square" @click="delDisDept(idx)"></i></td>
                    </tr>
                  </tbody>
                </table>
             </el-form>
             <el-form  label-width="95px">
                <el-form-item label="个人接收应用：">
                  <el-button type="primary" @click="showApp('disPersonal')">选择</el-button>
                </el-form-item>
                <div  style="padding:5px;padding-bottom:2px;border:1px #ddd solid" v-show="data.disPersonal.length>0">
                   <el-button  :key="it.id" v-for="it in data.disPersonal">{{it.name}}
                   </el-button>
                </div>
             </el-form>
             <el-form  label-width="65px">
                <el-form-item label="字段对应：">
                </el-form-item>
                <table class="inner_table">
                  <colgroup>
                    <col style="width:108px">
                    <col style="width:108px">
                    <col style="width:39px">
                  </colgroup>
                  <tbody>
                    <tr><th>接收表单字段</th><th>取值表达式</th><th><i class="fa fa-plus-square" @click="addMapping()" title="新增"></i></th></tr>
                    <tr :key="idx" v-for="(it,idx) in data.disMapping">
                    <td><input type='text' v-model="it['f']"/></td>
                    <td><input type='text' v-model="it['t']"/></td>
                    <td><i class="fa fa-minus-square" @click="delMapping(idx)"></i></td>
                    </tr>
                  </tbody>
                </table>
             </el-form>
        </el-collapse-item>
        <el-collapse-item title="其他" name="4">
           <el-form  label-width="80px">
           <el-form-item label="移动端新启:" >
                <el-radio-group v-model="data['mobileNewApp']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                 </el-radio-group>
            </el-form-item>
            <el-form-item label="执行脚本：">
                <el-button type="primary" @click="showFlowScriptSet('process')">设置</el-button>
            </el-form-item>
            </el-form>
        </el-collapse-item>
      </el-collapse>
</div>
    `,
    props: {
      data: {
        type: Object
      },
      params:{
        type: Object
      }
    },
    data() {
      return {
        activeName: '1',
        fieldItems:[]
      };
    },
    created() {
      /*if (this.data.subProcess == undefined) {
        this.$set(this.data, 'subProcess', 0)
      }*/
      if(this.data.disPersonal == undefined){
        this.$set(this.data, 'disPersonal', []);
      }
      if(this.data.disUnit == undefined){
        this.$set(this.data, 'disUnit', []);
      }
      if(this.data.disDept == undefined){
        this.$set(this.data, 'disDept', []);
      }

      if(this.data.disDefUnit == undefined){
        this.$set(this.data, 'disDefUnit',[]);
      }
      if(this.data.disDefDept == undefined){
        this.$set(this.data, 'disDefDept',[]);
      }

      if(this.data.disMapping == undefined){
        this.$set(this.data, 'disMapping', []);
      }
      if(this.data.mobileNewApp == undefined){
         this.$set(this.data, 'mobileNewApp', 1)
      }
      if(this.params.content && this.params.content.items){
        this.getFields(this.params.content.items);
      }
    },
    mounted() {
      var me = this;
    },

    methods: {
      delDisUnit(idx){
        this.data.disUnit.splice(idx,1)
      },
      addDisUnit(){
        var me = this;
        me.data.disUnit.push({u:'',un:'',a:'',an:''});
      },
      delDisDept(idx){
        this.data.disDept.splice(idx,1)
      },
      addDisDept(){
        var me = this;
        me.data.disDept.push({u:'',un:'',a:'',an:''});
      },

      delMapping(idx){
        this.data.disMapping.splice(idx,1)
      },
      addMapping(){
        var me = this;
        me.data.disMapping.push({f:'',t:''});
      },
      showDisUnit(idx,type){
        var me=this;
        var val=[];
        var data;
        var GO_OrgAndDep = false;
        if(type=='unit'){
          data=me.data.disUnit[idx];
        }else if(type=='dept'){
          GO_OrgAndDep = ((window.$Env && $Env.disConfigContaintDepartment) || false); //单位加部门
          data=me.data.disDept[idx];
        }
        if(data.u.trim()!==''){
          var u=data.u.split(",");
          var un=data.un.split(",");
          for(var i=0;i<u.length;i++){
            val.push({id:u[i],name:un[i]})
          }
        }
        PF.show('orgSelect', {
          config: {
            getConfig() {
              return {
                "LO": false,
                "userStrDelimiter": "#",
                "departmentNameProperty": "name",
                "GO_OrgAndDep": GO_OrgAndDep,
                "GO_onlyOrg":true,
                "hideLabel": true,
                "COO": false,
                "departmentStrDelimiter": "#",
                "xtype": "DepartmentUserSelection",
                "displayDelimiter": ",",
                "CG": false,
                "GO": true,
                "DO" : false,
                "SO" : false,
                "bodyStyle": {},
                "label": "接收单位",
                "POO": false,
                "dataMode": "2",
                "SOO": false,
                "labelAlign": "left",
                "PG": false,
                "activeTab": "全系统",
                "sizeCls": "large",
                "xtypeName": "机构及人员",
                "visible": true,
                "isFormField": true
              }
            }}, value: {DEP:val,DISPLAYNAME:val}}, function (res) {
          if(res.DEP.length>0){
            var u=[];
            var un=[];
            res.DEP.forEach(item=>{
              u.push(item.id);
              un.push(item.title?item.title:item.name);
            })
            data.u=u.join();
            data.un=un.join();
          }
        });
      },
      showDisDept(){
        var me=this;
        PF.show('orgSelect', {
          config: {
            getConfig() {
              return {
                "LO": true,
                "departmentNameProperty": "name",
                "hideLabel": true,
                "COO": false,
                "xtype": "DepartmentUserSelection",
                "displayDelimiter": ",",
                "CG": false,
                "GO": true,
                "bodyStyle": {},
                "label": "接收部门",
                "POO": false,
                "dataMode": "2",
                "labelAlign": "left",
                "PG": false,
                "activeTab": "本单位",
                "sizeCls": "large",
                "xtypeName": "机构及人员",
                "visible": true,
                "isFormField": true
              }
            }}, value: {DEP:me.data.disDept}}, function (data) {
          var dept=[];
          if(data.DEP.length>0){
            data.DEP.forEach(item=>{
              dept.push({id:item.id,name:item.name});
            })
          }
          me.data.disDept=dept;
        });
      },
      showApp(type,idx){
        var categories = 'module_flow';
        if("disPersonal"==type){
           categories='module_flow,module_normal';
        }
        let me=this;
        PF.show('treeTable',
          { url: PF.url("/api/app/listApplicationTreeByCategory"),
            treeDefaultParams:{categories:categories},
            selectFirst:true,
            clearBtn:true,
            changed:function(data){
              var me=this;
              if(data.applicationId)
                me.defaultParams={applicationId:data.applicationId,categories:categories};
              else
                me.defaultParams={owner:data.id,categories:categories};
            },
            api:'app.listApplicationItemsByCategory',
            singleSelect:true
          },
          function(res){
            var items = [];
            if(res && res.length>0){
              res.forEach(function(it){
                items.push({id:it.id,name:it.name});
              });
            }
            var data;
            if(type=='unit'){
              data= me.data.disUnit[idx];
              if(items.length>0){
                data.a=items[0].id;
                data.an=items[0].name;
              }else{
                data.a='';
                data.an='';
              }
            }else if(type=='dept'){
              data= me.data.disDept[idx];
              if(items.length>0){
                data.a=items[0].id;
                data.an=items[0].name;
              }else{
                data.a='';
                data.an='';
              }
            }else {
              me.data[type]=items;
            }
          });
      },
      showUnit(){
        var me = this,checkNodes=[];

        if(me.data['scope']){
          checkNodes=me.data['scope'].split(',');
        }
        PF.show('tree',{url: this.mwUrl("/api/org/getUnitTree"), checkNodes:checkNodes,search: false,multiple:true,singleLeaf:false,clearBtn:true,multipleLeaf:false},function(res){
          var scopeName = [];
          var scope = [];
          res.forEach(item => {
            scopeName.push(item.name);
            scope.push(item.id);
          });

          me.$set(me.data,'scopeName',scopeName.join(','));
          me.$set(me.data,'scope',scope.join(','));
        });
      },
      showFlowScriptSet(type){
        var me = this;
        var p = {};
        p.size='small_large';
        p.type = type;

        var scriptActions = me.data.scriptActions;
        if(scriptActions){
          p.scriptActions = scriptActions;
        }else{
          p.scriptActions ={};
        }
        PF.show('flowScriptSet',p,function(res){
          me.$set(me.data,'scriptActions',res);
        })
      },
      getFields(items) {
        let me=this;
        items.forEach(function(it){
          if(it.isFormField) {
            if(it.name)
              me.fieldItems.push({id:it.name,name:it.label});
            else
              me.fieldItems.push({id:it.id,name:it.label});
          }else{
            if(it.items){
              me.getFields(it.items);
            }
          }
        })
      },
    }
  }
  return backdrop
}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flowConfig/backdrop.js